import { ENDPOINTS } from '@shared/utils/constant'
import { streamProvider } from '@/providers/StreamProvider'
import { IndexerGrpcAccountPortfolioStream } from '@injectivelabs/sdk-ts/client/indexer'
import { StreamType } from '@/types'
import type { AccountPortfolioStreamCallback } from '@injectivelabs/sdk-ts'

export const portfolioStream = new IndexerGrpcAccountPortfolioStream(
  ENDPOINTS.indexer
)

export const cancelBankBalanceStream = () => {
  streamProvider.cancel(StreamType.BankBalance)
}

export const streamBankBalances = ({
  callback,
  accountAddress
}: {
  accountAddress: string
  callback: AccountPortfolioStreamCallback
}) => {
  const streamFn = portfolioStream.streamAccountPortfolio.bind(portfolioStream)
  const streamFnArgs = {
    accountAddress,
    callback
  }

  streamProvider.subscribe({
    fn: streamFn,
    args: streamFnArgs,
    key: StreamType.BankBalance
  })
}
